module.exports = function (app) {
    app.controller('pages.account', ['$scope', '$state', 'services', 'sessionData', 'aemContent', 'finder-logic2', '$cookies', 'brand','UMSParse',
        function ($scope, $state, services, sessionData, aemContent, finderLogic, cookies, brand,UMSParse) {

            $scope.headings = "Account Settings";
            $scope.showContactInformation = true; //
            $scope.showContactPreference = true; //
            $scope.showMemberProfile = false;
            $scope.showOtherInsurance = false;
            $scope.showPartnerProducts = false;
            $scope.showPasswordSecurity = true; 
            $scope.showPhysicianInformation = false;
            $scope.showTermsAndConditions = false;
            $scope.showTobaccoInformation = false;
            $scope.showViewIdCard = false;
            $scope.nd_wellnessProgramsIndicator =false;

            $scope.sidebar.links = [];

            $scope.planStates = {
                past: false,
                current: false,
                future: false
            };
            $scope.planTimes = {
                value: 'current'
            };
            var moreThanOneTimeFrame = false;
            var pcpActiveWindow = false;

            var theBrand = brand.current.sharedBrandCode.toLowerCase();

            var ums = sessionData.memberInfo;

            var lob;
            if (finderLogic.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Medical')) {
                lob = finderLogic.portalSelectedPlanSpecificProductByLatestCoverageEffectiveDate('Medical').lob;
            }
            var oidNumber = function () {
                switch (theBrand) {
                    case 'ibccr':
                        return '440899';
                    case 'ibcah':
                        return '440306';
                    case 'hmbcbs':
                    case 'hbs':
                    case 'hmbcbsde':
                    case 'hhic':
                    case 'ibc': //This is the shared brand code for inac
                        return '359288';
                    default:
                        return '440304';
                }
            };

            // ====================Getting past, current, and future coverage info====================
            var today = new Date();
            var umsParseData = new UMSParse(ums, today);
            var states = umsParseData.getPlansForWhen();
            var localCounter = 0;
            $scope.hasActivePlans = states.current;
            $scope.hasPastPlans = states.past;
            $scope.hasFuturePlans = states.future;
                        if (states.current) {
                            localCounter += 1;
                        }
                        if (states.past) {
                            localCounter += 1;
                        }
                        if (states.future) {
                            localCounter += 1;
                        }
                        if (localCounter > 1) {
                            moreThanOneTimeFrame = true;
                        }

                        if ($scope.hasActivePlans == false) {
                            $scope.planTimes = {value:"past"};
                        }
                        if ($scope.hasActivePlans == false && $scope.hasPastPlans == false) {
                            $scope.planTimes = {value:"future"};
                        }

            var planInfo = umsParseData.getPortalSelectedPlan();
            console.log("planInfo",planInfo);
            if (planInfo[0].productList.length > 0) {
                for (var x = 0; x < planInfo[0].productList.length; x++) {
                    var selectedPlan = planInfo[0].productList[x];

                    // =========================Physician Information=========================
                    if (selectedPlan.benefitPlanType.toUpperCase() === 'MEDICAL') {
                        // does this plan have active coverage? For PCP we check coverageEndDate and add 45 days grace period.  For POR, we just check the model for active coverage.
                        var currentDate = new Date();
                        var laterDate = "";
                        var gracePeriod = 45;
                        var finalDate = "";
                        var eDate = null;
                        var cDate = null;
                        var piLink;
                        var planCoverageEndDate = selectedPlan.coverageEndDate;
                        if (planCoverageEndDate) {
                            eDate = new Date(Date.parse(planCoverageEndDate));
                        }
                        var planCoverageCancelDate = selectedPlan.coverageCancelDate;
                        if (planCoverageCancelDate) {
                            cDate = new Date(Date.parse(planCoverageCancelDate));
                        }

                        // TODO: This date check needs to be revised.
                        // just to be safe, we need to check the cancel date vs. the coverage end date, and use the one that is later.
                        if (eDate && cDate) {
                            if (eDate <= cDate) {
                                laterDate = cDate;
                            } else {
                                laterDate = eDate;
                            }
                        } else {
                            laterDate = eDate;
                        }
                        finalDate = laterDate;
                        finalDate.setDate(finalDate.getDate() + gracePeriod);

                        // if a plan has multiple products, if one of them is in the active coverage window, we set the pcpActiveWindow flag to true.
                        if (finalDate <= currentDate) {
                            //TODO: This used to be a console.log. This if statement is ridiculous.
                        } else {
                            pcpActiveWindow = true;
                        }

                        // now let's set the PCP cookie and hide or show the PI link based on LOB and the active coverage window.
                        if (selectedPlan.lob.toUpperCase() === 'HMO' || selectedPlan.lob.toUpperCase() === 'POS') {
                            cookies.put("PCP", true); // this is PCP
                            if (pcpActiveWindow) {
                                $scope.showPhysicianInformation = true;

                                piLink = '/member/account/pi';

                                // piLink = teamsite.get("MBR_PHYSICIANINFO_LEFTNAV_LINK");
                            }
                        }
                        if ((lob) && (lob.toUpperCase() === 'PPO' || lob.toUpperCase() === 'EPO')) {
                            cookies.put("PCP", false); // this is POR, and we check for active coverage differently
                            if ($scope.hasActivePlans) {
                                $scope.showPhysicianInformation = true;

                                piLink = '/member/account/pi';

                                // piLink = teamsite.get("MBR_PHYSICIANINFO_LEFTNAV_LINK");
                            }
                        }
                        if (selectedPlan.benefitPlanName.toUpperCase() === 'IPA') {
                            cookies.put("PCP", true); // this is PCP
                            if (pcpActiveWindow) {
                                $scope.showPhysicianInformation = true;

                                piLink = '/member/account/pi';

                                // piLink = teamsite.get("MBR_PHYSICIANINFO_LEFTNAV_LINK");
                            }
                        }
                        if ((lob) && (lob.toUpperCase() === 'GPO')) {
                            cookies.put("PCP", true); // This is PCP
                            if (pcpActiveWindow) {
                                $scope.showPhysicianInformation = true;

                                piLink = '/member/account/pi';

                                // piLink = teamsite.get("MBR_PHYSICIANINFO_LEFTNAV_LINK");
                            }
                        }
                        if (theBrand === "ibccr" || theBrand === "ibcah") {
                            if (cookies.get("PCP") == "false") {
                                $scope.showPhysicianInformation = false;
                                piLink = '';
                            } else { // this case can be removed if IBC goes to new member portal for PI link
                                if (pcpActiveWindow) {

                                    if (selectedPlan.isBlueExtraBasic === 'true' || selectedPlan.isBlueExtraPlus === 'true') {

                                        $scope.showPhysicianInformation = false;
                                        piLink = '';
                                    } else {
                                        $scope.showPhysicianInformation = true;
                                        piLink = '/chmptl/chm/jsp/categorydetail.do?oid=' + oidNumber + '&parentId=-14492&type=program&tabTitle=yourCoverage';
                                    }
                                }
                            }
                        }
                        if (theBrand === "mincr") {
                            // MN Core does not get POR
                            if ($scope.showPhysicianInformation && lob &&
                                (lob.toUpperCase() === 'PPO' || lob.toUpperCase() === 'EPO')) {
                                $scope.showPhysicianInformation = false;
                                piLink = '';
                            }
                        }

                        var getAge = function (dob) {
                            var today = new Date();
                            var birthday = new Date(dob);
                            var age;

                            today.setHours(0);
                            today.setMinutes(0);
                            today.setSeconds(0);
                            today.setMilliseconds(0);
                            
                            age = ((today - birthday) / (1000 * 60 * 60 * 24 * 365));
                            
                            return age;
                        };

                        if (selectedPlan.hcrProduct) {
                            var age = getAge(selectedPlan.memberList[0].contact.birthDate);
                            if (theBrand === 'ibccr' || theBrand === 'ibcah') {
                                if (age >= 21) {
                                    $scope.showTobaccoInformation = true;
                    }
                            } else {
                                if (selectedPlan.effectuatedDate && age >= 18) {
                                    $scope.showTobaccoInformation = true;
                                }
                            }
                        }
                    }


                    // =========================Other Insurance=========================
                    if ((selectedPlan.benefitPlanType.toUpperCase() === 'MEDICAL') && (selectedPlan.seniorProductIndicator === 'false' && planInfo[0].medicareIndicator === 'false') || (planInfo[0].medigapIndicator === 'true')) {
                        $scope.showOtherInsurance = true;
                    }

                    // =========================Member Profile=========================
                    if ((selectedPlan.seniorProductIndicator === 'false' || selectedPlan.isBlueExtraBasic === 'true' ||
                        selectedPlan.isBlueExtraPlus === 'true') && theBrand !== "mincr") {
                        $scope.showMemberProfile = true;
                    }

                    // =========================Contact Preference=========================
                    if (selectedPlan.isBlueExtraBasic === 'true' || selectedPlan.isBlueExtraPlus === 'true') {
                        $scope.showContactPreference = false;
                    }
                }
            }

            // =========================Push links to sidebar=========================

            if (moreThanOneTimeFrame) {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_MBRINFO_LEFTNAV_HEADING"></span>',
                    label: '<span data-aem-content="MBR_MBRINFO_LEFTNAV_TITLE"></span>',
                    href: '/member/account/membership-information',
                    state: "account.membershipInformation",
                    description: '<span data-aem-content="MER_MBRINFO_LEFTNAV"></span>',
                    //refineTemplate: 'pages/account/membership-information/refine-membership-information.html',
                    refineTemplate: 'account/membership-information.appTemplate.html/chmhom/pages/account/membership-information/refine-membership-info',
                    refineController: 'pages.account.membership-information'
                });
            } else {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_MBRINFO_LEFTNAV_HEADING"></span>',
                    label: '<span data-aem-content="MBR_MBRINFO_LEFTNAV_TITLE"></span>',
                    href: '/member/account/membership-information',
                    state: "account.membershipInformation",
                    description: '<span data-aem-content="MER_MBRINFO_LEFTNAV"></span>'
                });
            }

            if ($scope.showContactInformation) {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_CNTCTINFO_LEFTNAV_HEADING"></span>',
                    label: '<span data-aem-content="MBR_CNTCTINFO_LEFTNAV_TITLE"></span>',
                    //href:'/mbr/#!/account/contact-information',
                    state: "account.contactInformation",
                    description: '<span data-aem-content="MER_CNTCTINFO_LEFTNAV"></span>'
                });
            }
            if ($scope.showPasswordSecurity) {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_PSWDSEC_LEFTNAV_HEADING"></span>',
                    label: '<span data-aem-content="MBR_PSWDSEC_LEFTNAV_TITLE"></span>',
                    //href:'/mbr/#!/account/password-security',
                    state: "account.passwordSecurity",
                    description: '<span data-aem-content="MER_PSWDSEC_LEFTNAV"></span>'
                });
            }
            if ($scope.showContactPreference) {
                $scope.sidebar.links.push({
                    // heading: '<span data-teamsite="MBR_CNTCTPREF_LEFTNAV_HEADING"></span>', //No teamsite content
                    heading: 'Set Contact Preferences',
                    label: '<span data-aem-content="MBR_CNTCTPREF_LEFTNAV_TITLE"></span>',
                    state: "account.contactPreferences",
                    //href:'/mbr/#!/account/contact-preferences',
                    description: '<span data-aem-content="MER_CNTCTPREF_LEFTNAV"></span>'
                });
            }
            if ($scope.showMemberProfile && theBrand !== 'wybcbs') {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_MEMBERPROFILE_LEFTNAV_HEADING"></span>',
                    label: '<span data-aem-content="MBR_MEMBERPROFILE_LEFTNAV_TITLE"></span>',
                    state: "account.memberProfile",
                    //href:'/mbr/#!/account/member-profile',
                    description: '<span data-aem-content="MBR_MEMBERPROFILE_LEFTNAV_DESC"></span>'
                });
            }
            if ($scope.showTobaccoInformation && theBrand !== 'wybcbs' && theBrand !== 'ndbcbs') {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MER_TOBACCOINFO_LEFTNAV_HEAD"></span>',
                    label: '<span data-aem-content="MER_TOBACCOINFO_LEFTNAV_TITLE"></span>',
                    state: "account.tobaccoInformation",
                    //href:'/mbr/#!/account/tobacco-information',
                    description: '<span data-aem-content="MER_TOBACCOINFO_LEFTNAV_DESC"></span>'
                });
            }
            if ($scope.showOtherInsurance) {
                $scope.sidebar.links.push({
                    heading: '<span data-aem-content="MBR_COB_LeftNav_Headline"></span>',
                    label: '<span data-aem-content="MBR_COB_LeftNav_Title"></span>',
                    state: "account.otherInsurance",
                    description: '<span data-aem-content="MBR_COB_LeftNav_Description"></span>'
                });
            }
            if ($scope.showPartnerProducts) {
                $scope.sidebar.links.push({
                    heading: 'Partner Products',
                    label: 'Partner Products',
                    state: "account.partnerProducts",
                    description: '<span>Partner products description here.</span>'
                });
            }
            if ($scope.showTermsAndConditions) {
                $scope.sidebar.links.push({
                    heading: 'Terms and Conditions',
                    label: 'Terms and Conditions',
                    state: "account.termsAndConditions",
                    description: '<span>Terms and conditions description here.</span>'
                });
            }

            if ($scope.showViewIdCard) {
                $scope.sidebar.links.push({
                    heading: 'View ID Card',
                    label: 'View ID Card',
                    state: "account.viewIdCard",
                    //href:'/mbr/#!/account/view-id-card?c=1-0-0-0',
                    description: '<span>View ID card description here.</span>'
                });
            }
            if (($scope.showPhysicianInformation) && theBrand !== 'wybcbs' && theBrand !== 'ndbcbs') {
                $scope.sidebar.links.push({
                    heading: 'Physician Information',
                    label: 'Physician Information',
                    state: 'account.physicianInformation',
                    href: piLink
                });}

            if (theBrand.toLowerCase() === 'ndbcbs') {
                $scope.sidebar.links.push({
                        label: '<span data-aem-content="MBR_HIPAAAUTH_LEFTNAV_TITLE"></span>',
                        // href: '#/HIPAA'
                        state: 'HIPAA'
                    },
                    {
                        label: '<span data-aem-content="MBR_PRENATALPLUS_LEFTNAV_TITLE"></span>',
                        // href: '#/prenatal'
                        state: 'prenatal'
                    });
            }
            if(theBrand.toLowerCase() === 'ndbcbs'){
                var username = ums.userName;
                var postData = {
                    "brand" : ums.brand,
                    "memberQualifierInfo": {
                        "clientNumber": ums.clientList[0].clientNumber,
                        "groupNumber": ums.clientList[0].groupList[0].groupNumber,
                        "qualifierList": [
                            "webMDRewardsIndicator",
                            "rxCarveOutVendor",
                            "wellnessProgramsIndicator",
                            "wellnessProgramsOptInOutIndicator"
                        ]
                    }
                };
                services.rbsmbl.memberService().getData(postData,username).then(function(response){
                    $scope.nd_wellnessProgramsIndicator = response.data.payload.qualifierInfo.wellnessProgramsIndicator;
                    if($scope.nd_wellnessProgramsIndicator === "true"){
                        $scope.sidebar.links.push({
                            heading: "Wellness Programs",
                            label: "Wellness Programs",
                            //active: true,
                            description: "Please review your Wellness Program Settings.",
                            state: "account.webmd"
                        });
                    }
                });
            }
        }
    ]);

    return [{
        state: "account",
        postPassword: true,
        appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
        AppConfigMaintenanceKey: 'FULL_MAINTENANCE',
        url: "/account",
        views: {
            abstract: true,
            'body@': {
                template: bootstrap.templates['page-templates/categoryCustom.html'],
                controller: "pages.account"
            }
        },
        "content@account": {
            templateUrl: 'account/membership-information.appTemplate.html/chmhom/pages/account/membership-information/membership-information',
            controller: "pages.account.membership-information"
        }
    },
        {
            state: "account.membershipInformation",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'MEMBERSHIP_INFORMATION_MAINTENANCE',
            url: "/membership-information",
            views: {
                "content@account": {
                    templateUrl: 'account/membership-information.appTemplate.html/chmhom/pages/account/membership-information/membership-information',
                    controller: "pages.account.membership-information"
                }
            }
        },
        {
            state: "account.viewIdCard",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'VIEW_ID_CARD_MAINTENANCE',
            url: "/view-id-card",
            views: {
                "body@": {
                    templateUrl: 'account.appTemplate.html/chmhom/pages/account/view-id-card/view-id-card',
                    controller: "pages.account.view-id-card"
                }
            }
        },
        {
            state: "account.contactInformation",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'CONTACT_INFORMATION_MAINTENANCE',
            url: "/contact-information",
            views: {
                "content@account": {
                    templateUrl: 'account/contact-information.appTemplate.html/chmhom/pages/account/contact-information/contact-information',
                    controller: "pages.account.contact-information"
                }
            }
        },
        {
            state: "account.passwordSecurity",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'PASSWORD_SECURITY_MAINTENANCE',
            url: "/password-security",
            views: {
                "content@account": {
                    templateUrl: 'account/password-security.appTemplate.html/chmhom/pages/account/password-security/password-security',
                    controller: "pages.account.password-security"
                }
            }

        },
        {
            state: "account.contactPreferences",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'CONTACT_PREFERENCES_MAINTENANCE',
            url: "/contact-preferences",
            views: {
                "content@account": {
                    templateUrl: 'account/contact-preferences.appTemplate.html/chmhom/pages/account/contact-preferences/contact-preferences',
                    controller: "pages.account.contact-preferences"
                }
            }
        },
        {
            state: "account.memberProfile",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'MEMBER_PROFILE_MAINTENANCE',
            url: "/member-profile",
            views: {
                "content@account": {
                    templateUrl: 'account/member-profile.appTemplate.html/chmhom/pages/account/member-profile/member-profile',
                    controller: "pages.account.member-profile"
                }
            }
        },
        {
            state: "account.partnerProducts",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'PARTNER_PRODUCTS_MAINTENANCE',
            url: "/partner-products-and-services-authorization",
            views: {
                "content@account": {
                    templateUrl: 'account/partner-products-and-services-authorization.appTemplate.html/chmhom/pages/account/partner-products/partner-products',
                    controller: "pages.account.partner-products"
                }
            }
        },
        {
            state: "account.physicianInformation",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'PHYSICIAN_INFORMATION_MAINTENANCE',
            url: "/pi",
            views: {
                'body@': {
                    templateUrl: 'account/pi.appTemplate.html/chmhom/pages/account/physician-information/physician-information',
                    controller: "pages.account.physician-information"
                }
            }
        },
        {
            state: "account.termsAndConditions",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'TERMS_AND_CONDITIONS_MAINTENANCE',
            url: "/terms-and-conditions",
            views: {
                "content@account": {
                    templateUrl: 'account/terms-and-conditions.appTemplate.html/chmhom/pages/account/terms-and-conditions/terms-and-conditions',
                    controller: "pages.account.terms-and-conditions"
                }
            }
        },
        {
            state: "account.tobaccoInformation",
            postPassword: true,
            appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
            appConfigMaintenanceKey: 'TOBACCO_INFORMATION_MAINTENANCE',
            url: "/tobacco-information",
            views: {
                "content@account": {
                    templateUrl: 'account/tobacco-information.appTemplate.html/chmhom/pages/account/tobacco-information/tobacco-information',
                    controller: "pages.account.tobacco-information"
                }
            }
        },

        {
            state: "account.webmd",
            postPassword: true,
            url: "/webmdpreferences",
            views: {
                "content@account": {
                    templateUrl: "account/webmdpreferences.appTemplate.html/chmhom/pages/account/webmdpreferences/webmdprefrences",
                    controller: "pages.account.webmd"
                }
            }
        }
    ];
};